import { useEffect, useState } from 'react';

import { useCurrentUser } from 'utils/hooks/globalState/baseState/useCurrentUser';
import { useCurrentAccount } from 'utils/hooks/globalState/baseState/useCurrentAccount';
import { initPostHog } from 'utils/posthogService';

const POSTHOG_SURVEY_ROOT_SELECTOR = '[class*="PostHogSurvey"]';

export const useInitialisePosthog = () => {
  const currentUser = useCurrentUser();
  const currentAccount = useCurrentAccount();

  const [isPosthogInitialised, setIsPosthogInitialised] = useState(false);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      const { target } = event;
      if (!(target instanceof HTMLElement)) return;
      if (target.closest(POSTHOG_SURVEY_ROOT_SELECTOR)) {
        event.stopPropagation();
      }
    };

    document.body.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.body.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  useEffect(() => {
    if (
      !isPosthogInitialised &&
      currentUser &&
      currentAccount &&
      currentAccount.subProcessors.posthog.enabled
    ) {
      initPostHog(currentAccount, currentUser);
      setIsPosthogInitialised(true);
    }
  }, [
    currentAccount,
    currentUser,
    isPosthogInitialised,
    setIsPosthogInitialised,
  ]);
};
